import httpClient from '@/http-client'
import config from '../config'

export const get = (options = {}) => {
  return httpClient
    .get(`${config.apiPrefix}/exchange-rates`, options)
    .then(response => response.data)
    .catch(error => Promise.reject(error.response ? error.response.data : error))
}

export default { get }
